module.exports = __webpack_public_path__ + "static/media/Categoria4Textil.31cba83a.jpg";